import React from 'react';
import Layout from '../components/Layout';

const Feedback: React.FC = () => {
  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Feedback</h1>
          <p className="mt-1 text-sm text-gray-500">
            Thank you for your feedback! This helps us improve our matching.
          </p>
        </div>

        <div className="bg-white shadow rounded-lg p-6">
          <div className="text-center py-8">
            <div className="text-6xl mb-4">✅</div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Feedback Recorded
            </h3>
            <p className="text-gray-600">
              Your feedback has been recorded and will help us improve future recommendations.
            </p>
            <div className="mt-6">
              <a
                href="/dashboard"
                className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Return to Dashboard
              </a>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Feedback;